import { render, staticRenderFns } from "./ResultRankDetail.vue?vue&type=template&id=42ccd57b&scoped=true&"
import script from "./ResultRankDetail.vue?vue&type=script&lang=ts&"
export * from "./ResultRankDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ResultRankDetail.vue?vue&type=style&index=0&id=42ccd57b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccd57b",
  null
  
)

export default component.exports